import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";

import { isPublicSiteHost } from "./config";
import { preloadPublicRoute } from "./routes/publicRouteModules";
import { i18n, initializeI18n } from "./translate/i18n";

const isPublicSite = isPublicSiteHost();

if (isPublicSite && typeof window !== "undefined") {
	void import("./services/facebookParameters").then(({ collectFacebookParameters }) =>
		collectFacebookParameters(window.location.href)
	).catch(() => undefined);
	void preloadPublicRoute(window.location.pathname).catch(() => undefined);
}

const appModulePromise = isPublicSite
	? import("./PublicApp")
	: import("./App");

const redirectLoggedOutRootVisitor = () => {
	if (typeof window === "undefined") return;

	const atRootPath =
		window.location.pathname === "/" || window.location.pathname === "";

	if (!atRootPath || isPublicSite) return;

	let hasToken = false;
	try {
		hasToken = Boolean(localStorage.getItem("token"));
	} catch (err) {
		hasToken = false;
	}

	if (!hasToken) {
		window.location.replace("/login");
	}
};

redirectLoggedOutRootVisitor();

void import("./services/runtimeRefreshGuard").then(({ startRuntimeRefreshGuard }) => {
	startRuntimeRefreshGuard();
});


const renderApp = async () => {
	const { default: App } = await appModulePromise;
	const publicPathRequiresI18n =
		isPublicSite &&
		typeof window !== "undefined" &&
		(/^\/simulator\/?$/.test(window.location.pathname) ||
			/^\/interviews(?:\/|$)/.test(window.location.pathname));

	if (!isPublicSite || publicPathRequiresI18n) {
		await initializeI18n();
	}

	createRoot(document.getElementById("root")).render(
		<HelmetProvider>
			<I18nextProvider i18n={i18n}>
				<App />
			</I18nextProvider>
		</HelmetProvider>
	);

	if (isPublicSite && !publicPathRequiresI18n) {
		window.setTimeout(() => {
			void initializeI18n().catch(error => {
				console.error("Failed to initialize i18n", error);
			});
		}, 0);
	}
};

renderApp().catch(error => {
	console.error("Failed to initialize application", error);
});
